var map = {
	"./1/symbol_0.png": "9a43",
	"./1/symbol_1.png": "414f",
	"./1/symbol_10.png": "99ec",
	"./1/symbol_11.png": "9684",
	"./1/symbol_12.png": "750b",
	"./1/symbol_2.png": "79bd",
	"./1/symbol_3.png": "e1f5",
	"./1/symbol_4.png": "1e69",
	"./1/symbol_5.png": "c437",
	"./1/symbol_6.png": "6b28",
	"./1/symbol_7.png": "031c",
	"./1/symbol_8.png": "3cff",
	"./1/symbol_9.png": "6144",
	"./2/symbol_0.png": "6dac",
	"./2/symbol_1.png": "926c",
	"./2/symbol_10.png": "58af",
	"./2/symbol_11.png": "7e38",
	"./2/symbol_12.png": "5a95",
	"./2/symbol_2.png": "805c",
	"./2/symbol_3.png": "8aea",
	"./2/symbol_4.png": "aabf",
	"./2/symbol_5.png": "a863",
	"./2/symbol_6.png": "ddad",
	"./2/symbol_7.png": "629e",
	"./2/symbol_8.png": "635a",
	"./2/symbol_9.png": "30e7",
	"./3/symbol_0.png": "c65d",
	"./3/symbol_1.png": "396d",
	"./3/symbol_10.png": "8218",
	"./3/symbol_12.png": "a6a4",
	"./3/symbol_2.png": "b38a",
	"./3/symbol_3.png": "a483",
	"./3/symbol_4.png": "bf72",
	"./3/symbol_5.png": "a738",
	"./3/symbol_6.png": "dfc9",
	"./3/symbol_7.png": "88a8",
	"./3/symbol_8.png": "a6e4",
	"./3/symbol_9.png": "f7f19",
	"./4/symbol_0.png": "ba26",
	"./4/symbol_1.png": "07da",
	"./4/symbol_10.png": "1210",
	"./4/symbol_12.png": "bba1",
	"./4/symbol_2.png": "532f",
	"./4/symbol_3.png": "5d59",
	"./4/symbol_4.png": "1435",
	"./4/symbol_5.png": "a69d",
	"./4/symbol_6.png": "b236",
	"./4/symbol_7.png": "5823",
	"./4/symbol_8.png": "4f1c",
	"./4/symbol_9.png": "5202",
	"./gamble/btn_HIGH_lose.png": "b638",
	"./gamble/btn_HIGH_normal.png": "e4f7",
	"./gamble/btn_HIGH_win.png": "5294",
	"./gamble/btn_LOW_lose.png": "d8c2",
	"./gamble/btn_LOW_normal.png": "b07b",
	"./gamble/btn_LOW_win.png": "bb9e",
	"./gamble/btn_collect.png": "635f",
	"./gamble/history_lose.png": "c4d6",
	"./gamble/history_win.png": "bd4f",
	"./gamble/wheel_HIGH_lose.png": "9c10",
	"./gamble/wheel_HIGH_win.png": "3521",
	"./gamble/wheel_LOW_lose.png": "ed22",
	"./gamble/wheel_LOW_win.png": "bf47",
	"./gold1.png": "e6ed",
	"./gold2.png": "613e",
	"./gold3.png": "6d1e",
	"./gold4.png": "268e",
	"./header_slotmachine_freespin._no_fg.png": "b0b6",
	"./silver1.png": "e186",
	"./silver2.png": "d1c0",
	"./silver3.png": "4857",
	"./silver4.png": "e683",
	"./slotmachine.png": "cd62"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2589";